/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description React Hook useWorkLists
 */
import _ from 'lodash';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import api from 'client/index';
import QUERY_KEYS from 'app-constants/queryKeys';
import { updateApiParamsCriteria } from 'utils/advancedFilterUtils';
import { getWorklistAdfFieldMap } from 'utils/adfUtils';
import { useCustomAttributesStoreValues } from 'store/customAttributes';
import { CUSTOM_ATTRIBUTE_ENTITY_TYPE } from 'app-constants/admin/customAttribute';

/**
 * use claim work lists hook
 * @returns {UseQueryResult} useWorkLists
 */
interface IProps {
	entityType: ClaimWorkLists.IWorkListEntityType;
	userWorklists: boolean;
	allWorklists?: boolean;
	searchWorklist?: ClaimWorkLists.ISearchWorklist;
	pageNumber?: number;
	pageSize?: number;
}
const useWorkLists = ({
	userWorklists,
	entityType,
	allWorklists = false,
	searchWorklist = {},
	pageNumber,
	pageSize,
}: IProps): UseQueryResult<ClaimWorkLists.IPaginatedWorkLists> => {
	const { customAttributes } = useCustomAttributesStoreValues();
	const worklistCustomAttributes = customAttributes?.[CUSTOM_ATTRIBUTE_ENTITY_TYPE.worklist];
	return useQuery({
		queryKey: [
			QUERY_KEYS.claimWorkLists,
			{ userWorklists, entityType, searchWorklist, allWorklists, pageNumber, pageSize, worklistCustomAttributes },
		],
		queryFn: async () => {
			const { data } = await api.WorklistApi.getWorklists({
				entityType,
				userWorklists,
				getAllWorklists: allWorklists,
				searchWorklist: updateApiParamsCriteria(_.cloneDeep(searchWorklist), getWorklistAdfFieldMap(worklistCustomAttributes)),
				pgNum: pageNumber,
				pgSize: pageSize,
			});
			return data;
		},
	});
};

export default useWorkLists;
